module.exports = __webpack_public_path__ + "static/avatar_flk-7d0945294f48afcea354e4f1ac87f88c.png";